const virtualSettings = (state, action) => {
  if (state === undefined) {
    return {
      customer_ip: null,
      override_limits: false,
    };
  }
  switch (action.type) {
    case 'UPDATE_PROFILE':
      if (state.virtualSettings.customer_ip !== null) {
        return state.virtualSettings;
      }
      return {
        ...state.virtualSettings,
        customer_ip: action.payload.customer_ip,
      };
    case 'VIRTUAL_SETTINGS':
      return {
        ...state.virtualSettings,
        ...action.payload,
      };
    default:
      return state.virtualSettings;
  }
};

export { virtualSettings };
